










































































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  Operation,
  Company,
  Admin
} from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { operations, AdminCommonReq, users, GetOperateReq } from "@/api/admin";
import { CompanyCommonReq, geCompanys } from "@/api/company";

import * as moment from "moment-timezone";
import { formatDateTime } from "../../utils/dateUtil";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination
  }
})
export default class Operations extends Vue {
  private searchOperate: Operation = <Operation>{};
  private list: Operation[] = [];
  private listLoading: boolean = true;
  private total = 0;
  private isSearch = false;
  private parentMeter: string = "";
  private listQuery: GetOperateReq = <GetOperateReq>{
    page: 1,
    pageSize: 10
  };

  public async getList() {
    this.listLoading = true;
    let req: GetOperateReq = <GetOperateReq>{};
    if (this.isSearch) {
      req.searchCompanyID = this.searchOperate.companyID;
      req.adminID = this.searchOperate.adminID;
      req.page = this.listQuery.page;
      req.pageSize = this.listQuery.pageSize;
    } else {
      req = this.listQuery;
    }
    const res = await operations(req);
    if (res.code === ResCode.SUCCESS) {
      this.list = res.data.adminOperationData.list;
      let zone = UserModule.zone;

      for (let o of this.list) {
        let date;
        if (!!zone) {
          let m = moment.utc(o.time * 1000).tz(zone);
          date = new Date(
            m.year(),
            m.month(),
            m.date(),
            m.hours(),
            m.minutes()
          );
        } else {
          date = new Date(o.time * 1000);
        }
        o.date = formatDateTime(date);
      }
      this.total = res.data.adminOperationData.totalCount;
    }
    this.listLoading = false;
  }
  public onSelectChangeCompany() {
    this.queryCompany("");
  }
  public onSelectChangeAdmin() {
    this.queryAdmin("");
  }
  private resetSearch() {
    this.searchOperate = <Operation>{};
  }
  private search() {
    this.isSearch = true;
    this.getList();
  }
  private loading = false;
  private queryCompanys;
  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }

  private queryUsers;
  public async queryAdmin(query) {
    let req: AdminCommonReq = <AdminCommonReq>{};
    let company: Admin = <Admin>{};
    req.page = 1;
    req.pageSize = 10;
    req.admin = <Admin>{ userName: query };
    this.loading = true;
    const res = await users(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryUsers = res.data.users.list;
      this.loading = false;
    }
  }
  private keys;
  private created() {
    this.keys = this.$t('routeDetail');
    this.getList();
  }
}
